<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <form @submit.prevent="resetPw">
                <card type="login">
                  <h4 style="font-size:18px;" slot="header" class="header text-center">Reset Your Password</h4>
			   <fg-input v-model="model.email" addon-left-icon="nc-icon nc-single-02"
                            placeholder="Email"></fg-input>
                            
                            
                <fg-input v-model="model.password" addon-left-icon="nc-icon nc-key-25" placeholder="New Password"
                            type="password"></fg-input>
                            
            	<fg-input v-model="model.c_password" addon-left-icon="nc-icon nc-key-25" placeholder="Confirm Password"
                            type="password"></fg-input>

                  <br>

    

                  <p-button native-type="submit" slot="footer" type="warning" round block class="mb-3">Reset Password</p-button>
                </card>
              </form>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div class="full-page-background" style="background-image: url(static/img/background/background-3.jpg) "></div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card, Checkbox, Button } from 'src/components/UIComponents';
  import AppNavbar from './Layout/AppNavbar'
  import AppFooter from './Layout/AppFooter'
  import {UserService} from 'src/services/user.service'
  import swal from 'sweetalert2'
  import ApiService from '@/services/api.service';


  export default {
    components: {
      Card,
      AppNavbar,
      AppFooter,
      [Checkbox.name]: Checkbox,
      [Button.name]: Button
    },
      mounted(){
    
    	this.model.token = this.$route.params.token;
    
    },
    
    methods: {
      toggleNavbar() {
        document.body.classList.toggle('nav-open')
      },
      closeMenu() {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      resetPw(){
      		const vm = this;
      		
      		swal.showLoading();
      		
      		let uri = this.$base_url+'/api/v1/user_reset_password';
      		ApiService.post(uri, this.model).then(response => {
			if(response.data.message == "not_exist"){
         				swal({
							title: `Oops`,
							text: "Something is wrong. Please check your email and email address.",
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
			   }
			   else if(response.data.message == "success"){
         				 swal({
							title: `Success`,
							text: 'Your password has been updated successfully',
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-success',
							icon: 'success'
						  }).then(function(){
						  	
						  	
						  		vm.$router.push( '/login');
						  
						  
						  });
			   }
         		
     		 })
      
      
      
      
      },
      login(e) {
      	
      }
    },
    data() {
      return {
      	model:{
          token: '',
          password: '',
          c_password:'',
        }
      }
    },
    beforeDestroy() {
      this.closeMenu()
    }
  }
</script>
<style>
</style>
